<template>
  <div class="max-w-4xl mx-auto p-4 lg:p-6 bg-white shadow-md border border-gray-200 rounded py-5">
    <h1 class="text-2xl font-bold text-secondary mb-6">
      {{ translate('manage about section (intructor profile)', 'capitalize') }}
    </h1>

    <BlogPostForm 
      v-if="aboutPost" 
      :postData="aboutPost"
      :not-fillable="['status']" 
      @save="onSaveSuccess" 
      @cancel="onCancel" 
    />
    
    <div v-else class="flex justify-center py-8">
      <i class="pi pi-spin pi-spinner text-3xl text-[#6a3328]"></i>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useToast } from 'primevue';
import { showToast } from '@/composables/toast';
import { translate } from '@/composables/translate';
import BlogPostService from '@/services/BlogPostService';
import BlogPostForm from './BlogPostForm.vue';
import BlogPostStatus from '@/dictionary/BlogPostStatus';

const toast = useToast();
const blogPostStatus = new BlogPostStatus();
const aboutPost = ref({
  id: 100,
  title: '',
  author_name: '',
  text: '',
  status: blogPostStatus.ABOUT_POST,
  post_photo: null,
  tags: null
});

onMounted(() => {
  getAboutPostData();
});

async function getAboutPostData() {
  const response = await BlogPostService.getAboutBlogPost()
  if (response) {
    aboutPost.value = response;
  }
}

function onSaveSuccess() {
  getAboutPostData();
}

function onCancel() {
  showToast(toast, translate('canceled', 'ucfirst'), 'info');
}
</script>